import { useEffect } from 'react';
import { useUserId } from '../UserIdContext';
import { createApiClient, getAccessToken } from '../lib/apiClient';
import { notifyInfo } from '../lib/notifications';

const api = createApiClient();
export default function OperationNoticeWatcher() {
  const { user } = useUserId();
  useEffect(() => {
    let active = true, cursor = '', timer, controller;
    const poll = async () => {
      try {
        if (!getAccessToken()) { cursor = ''; return; }
        controller = new AbortController();
        const { data } = await api.get('/api/operaciones/avisos-operativos', {
          params: cursor ? { after: cursor } : {}, signal: controller.signal, timeout: 15000,
        });
        if (!active) return;
        const events = data.events || [];
        if (events.length > 3) notifyInfo(`Cambios en ${events.length} operaciones: ${[...new Set(events.map(event => event.sector))].join(', ')}.`);
        else for (const event of events) notifyInfo(`Operación ${event.action || 'actualizada'} en ${event.sector}${event.deposito ? ` · ${event.deposito}` : ''}${event.client ? ` · ${event.client}` : ''}.`);
        cursor = data.cursor || cursor;
        if (data.more) { timer = setTimeout(() => { timer = null; poll(); }, 100); return; }
      } catch (_error) { /* Retain the cursor and retry after transient connection failures. */ }
      finally { if (active && !timer) timer = setTimeout(() => { timer = null; poll(); }, 8000); }
    };
    poll();
    return () => { active = false; clearTimeout(timer); controller?.abort(); };
  }, [user?._id, user?.id]);
  return null;
}
